import axios from "axios";
import dayjs from "dayjs";

const API = process.env.REACT_APP_API_BASE_URL;

//login
export const loginUser = async (email: string, password: string, client_code: string) => {
  
  try {
    //console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);
    const response = await axios.post(
      `${API}/auth/login`,
      { email, password, client_code },
      { headers: { "Content-Type": "application/json" } }
    );

    // backend returns { username, email, token }
    // { username, token, clientId } = response.data; // 1st code commented out on jan/22/26
     const { token } = response.data;

      if (!token) {
      console.error("Invalid login response from server");
      return null;
    }
    //console.log("Login API Response:", API, response.data);

    // if (!username || !token || !clientId) {     // continuation of 1st code commented out on jan/22/26
    //   console.error("Invalid login response from server");
    //   return null;
    // }

    return response.data; //  return full object
  } catch (error: any) {
   const message =
  error.response?.data?.error ||
  error.response?.data?.message ||
  "Login failed. Please try again";

throw new Error(message);

  }
};
// fetchOrders function
export const fetchOrders = async () => {
  try {
    const token = localStorage.getItem('token');
    console.log("listorder token-------------------",token)
    const response = await axios.get(`${API}/master/listOrders`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Fetched Orders:", response.data);

    return response.data; 
  } catch (error) {
    console.error("Error fetching orders:", error);
    return [];
  }
};

// Fetch only confirmed orders
export const fetchConfirmedOrders = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API}/master/listOrders`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { order_status: 'Confirm' }, 
    });
    console.log("Fetched Confirmed Orders:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching confirmed orders:", error);
    return [];
  }
};

export const fetchPendingOrders = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API}/master/listOrders`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { order_status: 'Pending' }, 
    });
    console.log("Fetched Pending Orders:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching pending orders:", error);
    return [];
  }
};

export const fetchOrderByBillNo = async (billno: string | number) => {
  const token = localStorage.getItem('token');
  console.log("listorderdetails.... token-------------------", token);

  try {
    const response = await axios.post(
      `${API}/master/listSelectedOrders`,
      { billno }, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("API raw response:", response.data);
    if (response.data && response.data.master) {
      return response.data;
    }
    return null;

  } catch (error) {
    console.error("Error fetching order by bill no:", error);
    return null;
  }
};

//updating order status
export const updateOrderStatus = async (payload: any, voiceBlob?: Blob | null) => {
  try {
    const token = localStorage.getItem("token");

    const formData = new FormData();
    // append JSON fields
    Object.keys(payload).forEach((key) => {
      formData.append(key, payload[key]);
    });

    // append voice if exists
    if (voiceBlob) {
      formData.append("voice", voiceBlob, "voiceNote.webm");
    }

    const response = await axios.post(`${API}/master/updateOrderStatus`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Order status updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Failed to update order status:", error);
    throw error;
  }
};

//order status
export const fetchOrdersWithStatus = async (dateRange: { startDate: any; endDate: any }) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API}/master/listOrderStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        startDate: dateRange.startDate.format("YYYY-MM-DD"),
        endDate: dateRange.endDate.format("YYYY-MM-DD"),
      },
    });

    return response.data || []; 
  } catch (error) {
    console.error("Error fetching orders with status:", error);
    return [];
  }
};

// Fetch order status history 
export const fetchOrderStatusHistory = async (billNo: string) => {
  try {
    console.log("🔍 Sending billNo to API:", billNo); 
    const token = localStorage.getItem('token');
    console.log("listorderhistory.... token-------------------", token);

    const response = await axios.post(
      `${API}/master/listSelectedOrderStatus`,
      { billno: billNo },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log("API Response:", response.data); 
    return response.data.data || response.data;
  } catch (error) {
    console.error("Error fetching order history:", error);
    throw error;
  }
};

// Fetch product and party
export const fetchProductAndParty = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(
    `${API}/master/listProductandParty`,
   
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  console.log("👉 FULL API response:", response.data);

  return {
    products: response.data.products || [],
    party: response.data.party || [],
    billNo: response.data.billno?.[0]?.["billNo"] || 1, // safely extract bill no
    dealer : response.data.dealer
  };
};

//save order
export const saveOrder = async (payload: {
  masterData: {
    invno: number; //bill no
    date: string; // date
    customerName: string; 
    customerId: string;
    totalAmount: number; //totalname
    disc_amt: number; // discount amount
    disc_perc: number;// discount percentage
    tax_perc: number; //tax percentage
    trans_charge: number; //trans and others
    disc_perc_amt: number;
    tot_qty: number,
    tot_tot:number,
    tot_tax_amt:number,
    contact: string;
     tax_amt:number;
     ln_disc_tot:number;
    // vehicle:string;
    
  };
  tableData: {
    siNo: number;
    itemCode: string;
    description: string;
    unit: string;
    quantity: number;
    unitPrice: number;
    amount: number;
    total: number;
    tax_amt: number;
    tax_perc: number;
  }[];
}) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API}/master/saveOrder`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error(
      " Error saving order:",
      error.response?.data || error.message
    );
    throw error;
  }
};

//billno details
export const fetchOrderToEdit = async (invoiceNo: string) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/master/getOrderToEdit`,
      {
        billno: invoiceNo, // send invoice number to backend
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching order to edit:", error);
    throw error;
  }
};
//  update order
export const updateOrder = async (payload: {
  masterData: {
    invno: number;
    date: string;
    customerName: string;
    customerId: string;
    totalAmount: number;
    disc_amt: number;
    disc_perc: number;
    tax_perc: number;
    trans_charge: number;
    disc_perc_amt: number;
    tot_qty: number;
    tot_tot: number;
    tot_tax_amt: number;
    contact: string;
    user:string;
  };
  tableData: {
    siNo: number;
    itemCode: string;
    description: string;
    unit: string;
    quantity: number;
    unitPrice: number;
    amount: number;
    total: number;
    tax_amt: number;
    tax_perc: number;
    disc_perc: number;
    disc_amt:number;
  }[];
}) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/master/updateOrder`,  
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Error updating order:", error.response?.data || error.message);
    throw error;
  }
};

//update history editcount
export const fetchOrderUpdatedHistory = async (billNo: string | number) => {
  try {
    const token = localStorage.getItem("token");
    console.log("orderUpdatedHistory.... token-------------------", token);

    const response = await axios.post(
      `${API}/master/ordersAndUpdatedCounts`,
      { billno: billNo },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          
        },
      }
    );

    console.log(" Order Updated History Response:", response.data);

    return response.data || [];
  } catch (error) {
    console.error("Error fetching order updated history:", error);
    return [];
  }
};

//updated orderhistory
export const fetchOrderHistoryDetailed = async (billno: number | string, cnt: number) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/master/orderHistoryDetailed`,
      { billno, cnt },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    console.log(" Order History Detailed Response:", response.data);
    return response.data || { master: null, table: [] };
  } catch (error) {
    console.error(" Error fetching order history detailed:", error);
    return { master: null, table: [] };
  }
};

//api for bill no only
export const fetchBillNo = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API}/master/getBillNo`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("👉 Bill No API response:", response.data);

    // Safely return bill number, default to 1 if missing
    return response.data?.[0]?.billNo || 1;
  } catch (error) {
    console.error("Error fetching bill number:", error);
    return 1; // fallback bill number
  }
};

//leads section
export const fetchLeads = async (leads: any) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("No token found. Please log in again.");
    }

    const response = await axios.post(
      `${API}/leads/saveleads`,
      leads, //send the lead data in request body
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Saved Lead:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error saving lead:", error);
    throw error;
  }
};
//show the created leads on frontend
export const getLeads = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/leads/getleadsdata`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const leadsData = response.data;
    const leads = leadsData.map((lead: any) => ({
      ...lead,
       created_date: dayjs(lead.created_date).format("YYYY-MM-DD HH:mm:ss"), 
    }));
    return leads;
  } catch (error) {
    console.error("Error fetching leads:", error);
    return [];
  }
};

//Edit Lead
export const editLeads = async (
  leadId: number | string,
  leadData: any,
  voiceBlob?: Blob | null
) => {
  try {
    const token = localStorage.getItem("token");

    const formData = new FormData();

    // Append lead data
    Object.keys(leadData).forEach((key) => {
      formData.append(key, leadData[key]);
    });

    //formData.append("leads_id", leadId.toString());
   
    // Append voice if provided
    if (voiceBlob) {
      formData.append("voice", voiceBlob, "voiceNote.webm");
    }

    const response = await axios.post(
      `${API}/leads/updateleads`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data", 
        },
      }
    );

    console.log("Edit Lead Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error editing lead:", error);
    throw error;
  }
};

//delete lead
export const deleteLeads = async (leadId: number | string) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API}/leads/deleteleads`,
      { leads_id: leadId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Delete Lead Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting lead:", error);
    throw error;
  }
};
//getcompany details for phn,email,created date
export const getCompanyDetails = async (leads_id: number | string) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(
      `${API}/master/getcompanydetails`,
      { leads_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Get Company Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error getting company details:", error);
    throw error;
  }
};

//calender
export const createEvent = async (eventData: any) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API}/events/createEvent`,
      eventData,
       {
        headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
   return response.data;
  } catch (error) {
    console.error("Error creating event:", error);
    throw error;
  }
};
//display reminder on calender
export const getEvents = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/events/getEvent`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting events:", error);
    throw error;
  }
};

// fetch notifications
export const fetchNotifications = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/getNotification`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

// send event email
export const sendEmailNotification = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/sendEventEmails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error sending email notifications:", error);
    throw error;
  }
};
//save email
export const saveEmail = async (email: any) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API}/settings/saveEmail`,
      {email},
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
    return response.data;
  } catch (error) {
    console.error("Error saving email:", error);
    throw error;
  }
};
//fetch email
export const fetchEmail = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/settings/getNotificationSettings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching email:", error);
    throw error;
  }
};
//notification bar
export const fetchNotificationBar = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/notifications`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notification bar:", error);
    throw error;
  }
};
//checkbox sentEmailStatus
export const updateSentEmailStatus = async (status: any) => {
  try{
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API}/settings/sentEmailStatus`,
      {status},
      {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
    return response.data;
  } catch (error) {
    console.error("Error updating sent email status:", error);
    throw error;
  }
};
//get status values
export const getStatusValues = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/settings/getStatusValues`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting status values:", error);
    throw error;
  }
};
//db updates section

//createOrderStatus
export const createOrderStatus = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/createOrderStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating order status:", error);
    throw error;
  }
};
//createEventdetails
export const createEventdetails = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/createEventDetails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating event details:", error);
    throw error;
  }
};
//createleadsdetails
export const createleadsdetails = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/createLeadsDetails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating leads details:", error);
    throw error;
  }
};
//create orderhistory
export const createOrderHistory = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/createOrderHistory`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating order history:", error);
    throw error;
  }
};
//create userPrivilegeCrm table
export const createUserPrivilegeCrm = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/createUserPrivilege`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating order history:", error);
    throw error;
  }
};
//getCompany
export const fetchCompany = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/getCompany`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting company details:", error);
    throw error;
  }
};

//get recent leads


export const fetchRecentLeads = async (days: any) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/leads/getRecentLeads?days=${days}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching recent leads:", error);
    throw error;
  }
};

//order status on pie chart
export const fetchOrderStatusSummary = async (days: number) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API}/master/getOrdersStatusSummary`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { days },
    });

    return response.data || [];
  } catch (error) {
    console.error("Error fetching order status summary:", error);
    return [];
  }
};

// Fetch monthly completed orders area graph
export const fetchCompletedOrdersMonthly = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API}/master/getCompletedOrdersMonthly`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data || [];
  } catch (error) {
    console.error("Error fetching completed orders monthly:", error);
    return [];
  }
};

//get leads status summary
export const fetchLeadsStatusSummary = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/leads/getLeadsStatusSummary`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching leads status summary:", error);
    throw error;
  }
};

//get recent orders
export const fetchRecentOrders = async (days: any) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/getRecentOrders?days=${days}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching recent orders:", error);
    throw error;
  }
};

// bar graph on order dashboard
export const fetchOrderSummary = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/getOrderStatusCounts`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching order summary:", error);
    throw error;
  }
};
//list all event notifications
export const fetchEventNotifications = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/listNotifications`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching event notifications:", error);
    throw error;
  }
};
//to getuser for user Privilege
export const fetchUser = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/getUser`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user:", error);
    throw error;
  }
};

// Save privileges for a user
export const saveUserPrivilege = async (data: { userId: number; privileges: string[]; username: string }) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/master/saveUserPrivilege`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error saving user privilege:", error);
    throw error;
  }
};

//to get one user privileges
export const getUserPrivilege = async (userId: number) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(`${API}/master/getUserPrivilege`, {
      params: { userId },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data; // array of privilege names
  } catch (error) {
    console.error("Error fetching user privilege:", error);
    throw error;
  }
};


//to get users fro leads owner dropdown
export const fetchUsers = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/leads/getUsers`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};

//for global userprivilege condition
export const getUserPrivilegeByUsername = async (username: string) => {
  if (!username) throw new Error("Username is required");

  try {
    const token = localStorage.getItem("token");
    const clientId = localStorage.getItem("clientId"); 
    if (!clientId) throw new Error("Client ID is required");

    const response = await axios.get(`${API}/master/getUserPrivilegeByUsername`, {
      params: { username },
      headers: {
        Authorization: `Bearer ${token}`,
        "client-id": clientId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching user privilege:", error);
    throw error;
  }
};

//to fetch dates in leads by filtering
// ADD this export
export const fetchLeadsByDate = async (startDate: string, endDate: string) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/leads/getLeadsByDateRange`, {
      params: { startDate, endDate },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching leads by date:", error);
    throw error;
  }
};

//check db status(if they exist or not) 
export const checkDbStatus = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/master/checkDbStatus`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking DB status:", error);
    throw error;
  }
};

//task section
//create task
export const createTask = async (taskData: any) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${API}/task/createTask`, taskData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating task:", error);
    throw error;
  }
};

//getTaskdata
export const fetchTasks = async () => {
  try {
    const token = localStorage.getItem("token");

    const res = await axios.get(`${API}/task/getTasks`, {

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Fetched Tasks:", res.data);

    return res.data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    throw error;
  }
};

//update task
export const updateTask = async (taskId: number, updatedData: any) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.put(
      `${API}/task/updateTask/${taskId}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating task:", error);
    throw error;
  }
};

//delete task
export const deleteTask = async (taskId: number) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/task/deleteTask`,
      { task_id: taskId },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  }
};

//get billno and billparyname for task
export const fetchBillNoAndPartyName = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/task/getBillDetailsForTask`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching bill no and party name:", error);
    throw error;
  }
};

//get task details
export const fetchTaskReports = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${API}/task/getTaskReports`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    console.error("Error fetching task reports:", error);
    throw error;
  }
};

//update task status
export const updateTaskStatus = async (
  taskId: number,
  status: string,
  completed_date: string | null
) => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API}/task/updateTaskStatus/${taskId}`,
      {
        status,
        completed_date,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating task status:", error);
    throw error;
  }
};
//createtaskTable
export const createTaskTable = async () => {  
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API}/task/createTaskTable`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating task table:", error);
    throw error;
  }
};